<template>
  <v-btn :icon="showText === false" rounded :outlined="showText === true" color="grey darken-1" v-if="translations != null" @click="languageDialog = !languageDialog">
    <v-icon v-if="showIcon" :left="showText === true" color="grey darken-1">language</v-icon>
      <span v-if="showText">{{ selectedLanguage }}</span>
    <language-dialog :languageDialog="languageDialog" :translations="translations" @close="languageDialog= false"/>
  </v-btn>
</template>

<script>
import LanguageDialog from '@/components/ui/LanguageDialog'

export default {
  name: 'LanguageButton',
  components: {
    LanguageDialog
  },
  props: {
    showIcon: {type: Boolean, required: false, default: true},
    showText: {type: Boolean, required: false, default: true},
  },
  data () {
    return {
      languageDialog: false,
      currentLanguage: "",
    }
  },
  methods: {
    updateCurrentLanguage() {
      this.currentLanguage = this.$root.getCurrentLanguage();
    }
  },
  computed: {
    translations() {
      let available_translations = this.$root.getSetting('translations');
      if (available_translations == null) {
        return null;
      }
      return this.$root.getSetting('translations').map(lang => {
          return {
            text: lang.displayName,
            value: lang.code,
            disabled: false,
          }
        });
    },
    selectedLanguage() {
      let lang_code = this.currentLanguage;
      return lang_code;
    }
  },
  mounted() {
    this.updateCurrentLanguage();
    this.$nextTick(() => {
      this.updateCurrentLanguage();
    });
  },
  beforeDestroy() {
  },
  watch: {
    languageDialog() {
      this.updateCurrentLanguage();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/ui/LanguageButton.vue